import React from 'react';
import { TableOfContentsList, TableOfContentsListItem, TableOfContentsSubList } from './TableOfContents.styles';
import { TableOfContent } from 'src/functions/getTableOfContentDictionary';
import Button from 'atoms/Button/Button';
import Arrow from 'app/icons/Monospaced/Arrow/Arrow';

interface TableOfContentsLinksProps {
  tableOfContents: TableOfContent[];
  currentSectionId?: string;
}

const TableOfContentsLinks = ({ tableOfContents, currentSectionId }: TableOfContentsLinksProps): JSX.Element => {
  return (
    <TableOfContentsList>
      {tableOfContents.map((link, index) => (
        <TableOfContentsListItem key={index}>
          <Button
            size='lg'
            decoration='none'
            variant='text-link'
            href={`#${link.id}`}
            iconPosition='left'
            icon={currentSectionId === link.id ? <Arrow orientation='right' /> : null}
            className={`link-button ${currentSectionId === link.id ? 'active' : ''}`}
          >
            {link.content}
          </Button>
          {link.children && (
            <TableOfContentsSubList>
              {link.children.map((child, subIndex) => (
                <TableOfContentsListItem key={`${index}-${subIndex}`}>
                  <Button
                    variant='text-link'
                    size='lg'
                    decoration='none'
                    href={`#${child.id}`}
                    iconPosition='left'
                    icon={currentSectionId === child.id ? <Arrow orientation='right' /> : null}
                    className={`link-button ${currentSectionId === child.id ? 'active' : ''}`}
                  >
                    {child.content}
                  </Button>
                </TableOfContentsListItem>
              ))}
            </TableOfContentsSubList>
          )}
        </TableOfContentsListItem>
      ))}
    </TableOfContentsList>
  );
};

export default TableOfContentsLinks;
